import { useEffect, useState } from 'react';
import { useWindowSize } from 'react-use';

const useDevice = () => {
    const windowSize = useWindowSize();
    const [width, setWidth] = useState(windowSize.width);
    const [height, setHeight] = useState(windowSize.height);

    useEffect(() => {
        if (Math.abs(windowSize.width - width) >= 10)
            setWidth(windowSize.width);
        if (Math.abs(windowSize.height - height) >= 10)
            setHeight(windowSize.height);
    }, [height, width, windowSize]);

    return {
        width,
        height,
        containerHeight: height - 95,
        isSmartphone: width <= 900,
        isTablet: width <= 1145
    };
};

export default useDevice;